// extracted by mini-css-extract-plugin
export default {"dropdownCard":"SettingsMenu__dropdownCard___cMAXi","open":"SettingsMenu__open___HKfyQ"};